import _extends from 'babel-runtime/helpers/extends';

import { systemUserInfoAPI } from '@/api/common';
import { getImageData } from '@/utils';
import XRTheme from '@/styles/xr-theme.scss';
import { mapGetters } from 'vuex';

export default {
  // Avatar 头像
  name: 'XrAvatar',
  components: {
    XrUserView: function XrUserView() {
      return import('../XrUserView');
    }
  },
  inheritAttrs: false,
  props: {
    name: String,
    id: [Number, String],
    size: {
      type: [Number, String],
      default: 38
    },
    src: String,
    disabled: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: 'click'
    },
    background: {
      type: String,
      default: XRTheme.xrColorPrimary
    }
  },
  data: function data() {
    return {
      popoverShow: false,
      loading: false,
      userData: null
    };
  },

  computed: _extends({}, mapGetters(['imageCache']), {
    fontSize: function fontSize() {
      if (this.size <= 30) {
        return '12px';
      }
      return '14px';
    },
    showName: function showName() {
      return this.name && this.name.length > 2 ? this.name.slice(-2) : this.name;
    },
    popoverDisabled: function popoverDisabled() {
      if (this.disabled) {
        return true;
      }

      return !this.id;
    }
  }),
  watch: {
    popoverShow: function popoverShow(val) {
      if (!this.userData) {
        this.getUserData();
      }
    },

    src: {
      handler: function handler() {
        this.handleImage();
      },

      immediate: true
    }
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    handleImage: function handleImage() {
      var _this = this;

      if (this.src) {
        if (!this.imageCache.hasOwnProperty(this.src)) {
          this.$set(this.imageCache, this.src, '');
          this.$store.commit('SET_IMAGECACHE', this.imageCache);
          getImageData(this.src).then(function (data) {
            _this.$set(_this.imageCache, _this.src, data.src);
            _this.$store.commit('SET_IMAGECACHE', _this.imageCache);
          }).catch(function () {
            delete _this.imageCache[_this.src];
            _this.$store.commit('SET_IMAGECACHE', _this.imageCache);
          });
        }
      }
    },
    getUserData: function getUserData() {
      var _this2 = this;

      systemUserInfoAPI({
        id: this.id
      }).then(function (res) {
        _this2.userData = res.data;
      }).catch(function () {});
    }
  }
};